export type CreateOrderPageVersion = 'v1' | 'v2';

export const defaultCreateOrderPageVersion: CreateOrderPageVersion = 'v1';

export function chooseCreateOrderPageVersion(
    isOptInAllowed: boolean,
    savedChoice: string | undefined
): CreateOrderPageVersion {
    if (!isOptInAllowed) {
        return 'v1';
    }

    if (savedChoice === 'v1' || savedChoice === 'v2') {
        return savedChoice;
    }

    return defaultCreateOrderPageVersion;
}
